import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Entity, RoleEntityPermissionMap } from 'ag-common-lib/public-api';
import { hasPermissionGuard } from 'ag-common-svc/shared/utils/has-permission-guard';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ARMAuthService } from '../shared/services/util/arm-auth.service';

/**
 * Gates the board itself. Individual widgets are gated by their own entities, so this
 * permission alone opens an empty dashboard rather than exposing any data.
 */
@Injectable({ providedIn: 'root' })
export class DashboardGuard implements CanActivate {
  constructor(
    private authService: ARMAuthService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.armPermissions$.pipe(
      map((roleEntityPermissionMap: RoleEntityPermissionMap) => {
        return hasPermissionGuard([Entity.dashboard], roleEntityPermissionMap);
      }),
      tap(hasPermission => {
        if (!hasPermission) {
          this.router.navigate(['/access-denied']);
        }
      }),
    );
  }
}
